import React, { useEffect, useMemo, useState } from "react";
import { Col } from "reactstrap";
import { ODataGrid } from "../../Components/OElements/ODataGrid";
import UploadOneFileModal from "./Modal/UploadOneFileModal";
import { Link } from 'react-router-dom';
import { filesize } from "filesize";
import { toast } from "react-toastify";

const Files = ({
	folderId,
	fileTypeId,
	handleLocalFiles,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab
}) => {
	const [localFiles, setLocalFiles] = useState([]);
	const [modalUploadOneFile, setModalUploadOneFile] = useState(false);

	function handleToggleModalUploadOneFile() {
		setModalUploadOneFile(!modalUploadOneFile);
	}

	function handleUploadLocalFile(file, nameFileType) {
		let updatedLocalFiles = localFiles.map(item => item);
		updatedLocalFiles.push({
			filename: file.name,
			file_type: [{ name: nameFileType || '' }],
			size: file.size,
			creation_date: file.lastModifiedDate,
			file: file
		});
		setLocalFiles(updatedLocalFiles);
		toast.success(
			'Se ha añadido el archivo a subir exitosamente.',
			{ autoClose: 3000 }
		);
	}

	function handleDeleteLocalFile(fileIndex) {
		const updatedLocalFiles = localFiles.filter((item, index) => index != fileIndex);
		setLocalFiles(updatedLocalFiles);
		toast.error(
			'Se ha eliminado el documento exitosamente.',
			{ autoClose: 3000 }
		);
	}

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'file',
				columnDefType: 'display',

				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const { index } = cellProps.row;
													handleDeleteLocalFile(index);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'filename',
				filterVariant: 'autocomplete',
				Cell: cellProps => {
					return (
						<div className='d-flex align-items-center'>
							<div className='flex-grow-1 filelist-name'>
								{cellProps.row.original.filename}
								{cellProps.row.original.extension}
							</div>
						</div>
					);
				},
			},
			{
				header: 'Tipo',
				accessorKey: 'file_type',

				size: 'auto',
				Cell: ({ row }) => {
					return row?.original?.file_type?.length
						? row.original.file_type[0].name
						: '';
				},
			},
			{
				header: 'Importante',
				accessorKey: 'isFavourite',
				Cell: cellProps => {
					return (
						<div className='d-flex justify-content-center'>
							<button
								type='button'
								className={`btn btn-ghost-primary btn-icon btn-sm favourite-btn ${cellProps.row.original.isFavourite ? 'active' : ''
									}`}
								onClick={e =>
									favouriteBtn(e.target, cellProps.row.original._id)
								}
							>
								<i className='ri-star-fill align-bottom me-2 text-muted' />
							</button>
						</div>
					);
				},
			},
			{
				header: 'Tamaño',
				accessorKey: 'size',
				Cell: cellProps => {
					return (
						<div className='filelist-size'>
							{filesize(cellProps.row.original.size || 0)}
						</div>
					);
				},
			},
		],
		[localFiles]
	);

	useEffect(() => {
		handleLocalFiles(localFiles);
	}, [localFiles])

	return (
		<React.Fragment>
			<Col>
				<h5 className='flex-grow-1 fs-13 mb-0' id='filetype-title'>
					Archivos
				</h5>
			</Col>
			{/* <Col className='col-auto'>
				<div className='d-flex gap-2 align-items-start'>
					<button
						type='button'
						className='btn btn-success createFile-modal'
						onClick={() => { handleToggleModalUploadOneFile() }}
					>
						<i className='ri-plus-line label-icon'></i> Subir Archivo
					</button>
				</div>
			</Col> */}
			<ODataGrid
				key={'uploaded_local_files'}
				data={localFiles || []}
				columns={columns}
				customToolbarActions={[
					{
						label: 'Subir',
						icon: 'ri-plus-line',
						onClick: () => { handleToggleModalUploadOneFile() },
						title: 'Subir Archivo'
					}
				]}
			>
			</ODataGrid>
			
			<UploadOneFileModal
				isOpen={modalUploadOneFile}
				folderId={folderId}
				fileTypeId={fileTypeId}
				handleToggleModal={handleToggleModalUploadOneFile}
				handleUploadLocalFile={handleUploadLocalFile}
			/>
		</React.Fragment>
	)
}

export default Files;